import { useState, useCallback } from 'react'
import { Button, Popover, Stack, Typography, IconButton, Tooltip } from '@vapor/material'
import { faBed, faXmark, faPencil, faTrash } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ReservationLookup } from 'src/app/components/reservation-lookup/reservation-lookup'
import { reservationSearchFragment } from 'src/api/api.generated'
import { useTranslation } from 'react-i18next'

type LinkToReservationProps = {
  propertyId: string
  title: string
  onSelection: (reservationId: string | undefined) => void
}

export const LinkToReservation = (props: LinkToReservationProps) => {
  const { propertyId, title, onSelection } = props
  const { t } = useTranslation()
  const [selectedItem, setSelectedItem] = useState<reservationSearchFragment | null>(null)

  //#region popover
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }
  const open = Boolean(anchorEl)
  //#endregion

  const clearSelection = useCallback(() => {
    //clearConventionSelected()
    handleClose()
    setSelectedItem(null)
    onSelection(undefined)
  }, [handleClose, setSelectedItem])

  return (
    <>
      {!selectedItem ? (
        <Button size="small" variant="text" startIcon={<FontAwesomeIcon icon={faBed} />} onClick={handleClick}>
          {title}
        </Button>
      ) : (
        <table className="table" style={{ maxWidth: '400px', border: '1px solid rgb(224,224,224)' }}>
          <thead>
            <tr>
              <th style={{ border: '1px solid rgb(224,224,224)' }}>
                <Stack direction="row" spacing={0.5} justifyContent="flex-start" alignItems="center" ml={1}>
                  <FontAwesomeIcon icon={faBed} color="var(--DarkImperialBlue)" />
                  <Typography variant="body">
                    <b>{title}</b>
                  </Typography>
                </Stack>
              </th>
              <th style={{ width: '70px', border: '1px solid rgb(224,224,224)' }}>
                <Typography variant="body" style={{ maxWidth: '40px !important' }}>
                  <b>{t('commons.table_actions')}</b>
                </Typography>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={{ border: '1px solid rgb(224,224,224)' }}>
                <Stack direction="row" spacing={0} justifyContent="flex-start" alignItems="center" ml={1}>
                  <Tooltip title={`${selectedItem.reservationCode} - ${selectedItem.company ? `${selectedItem.company} (${selectedItem.mainGuest})` : selectedItem.mainGuest}`}>
                    <Typography noWrap style={{ width: 'calc(100%)' }} variant="body">
                      {`${selectedItem.reservationCode} - ${selectedItem.company ? `${selectedItem.company} (${selectedItem.mainGuest})` : selectedItem.mainGuest}`}
                    </Typography>
                  </Tooltip>
                </Stack>
              </td>

              <td style={{ border: '1px solid rgb(224,224,224)' }}>
                <Stack direction="row" spacing={0} justifyContent="center" alignItems="center">
                  <IconButton size="small" onClick={handleClick}>
                    <FontAwesomeIcon icon={faPencil} color="var(--RichElectricBlue)" />
                  </IconButton>
                  <IconButton size="small" onClick={clearSelection}>
                    <FontAwesomeIcon icon={faTrash} color="var(--MaximumRed)" />
                  </IconButton>
                </Stack>
              </td>
            </tr>
          </tbody>
        </table>
      )}

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <Stack direction="column" m={1}>
          <Stack direction="row">
            <Stack direction="row" spacing={0.5} justifyContent="flex-start" alignItems="center">
              <FontAwesomeIcon icon={faBed} />
              <Typography variant="body">
                <b>{title}</b>
              </Typography>
            </Stack>
            <div style={{ flexGrow: 2 }} />
            <IconButton size="small" onClick={handleClose}>
              <FontAwesomeIcon icon={faXmark} />
            </IconButton>
          </Stack>
          <ReservationLookup
            value={{ id: '' }}
            onChange={(item) => {
              setSelectedItem(item)
              if (item?.id) onSelection(item.id)
              handleClose()
            }}
            propertyId={propertyId}
          />
        </Stack>
      </Popover>
    </>
  )
}
